<script>
import Layout from '../../layouts/main'
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { GanttComponent, Selection, DayMarkers, Toolbar, ExcelExport, PdfExport } from "@syncfusion/ej2-vue-gantt";
import { labelData, editingResources } from './data-source';

export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader,
    'ejs-gantt': GanttComponent
  },
  data() {

    return {
      title: "Gestão de Projetos",
      items: [
        {
          text: "Administrativo",
          href: "/"
        },
        {
          text: "Gestão de Projetos",
          active: true
        }
      ],

      showModalTarefa: false,
      submittedTarefa: false,
      tarefaData: {},

      toolbar: [
          { text: 'Nova Tarefa', tooltipText: 'Nova Tarefa', id: 'novaTarefa', prefixIcon: 'e-icons  e-plus' },
          'ExpandAll', 'CollapseAll', "ExcelExport", "CsvExport", "PdfExport",


      ],
      data: labelData,
      height: '100%',
      taskFields: {
        id: 'TaskID',
        name: 'TaskName',
        startDate: 'StartDate',
        endDate: 'EndDate',
        duration: 'Duration',
        progress: 'Progress',
        dependency: 'Predecessor',
        resourceInfo: 'resources',
        child: 'subtasks'
      },
      columns: [
        { field: 'TaskID', headerText: 'ID', width: 75 },
        { field: 'TaskName', headerText: 'Descrição', width: 230 },
        { field: 'StartDate', headerText: 'Início' },
        { field: 'EndDate', headerText: 'Fim' },
        { field: 'Duration', headerText: 'Duração' },
        { field: 'Predecessor' },
        { field: 'Progress', headerText: 'Progresso' },
        { field: 'resources', headerText: 'Recursos' },
      ],
      resourceFields: {
        id: 'resourceId',
        name: 'resourceName'
      },
      resources: editingResources,
      labelSettings: {
        leftLabel: "leftLabelTemplate",
        rightLabel: "rightLabelTemplate",
        taskLabel: '${Progress}%'
      },
      splitterSettings: {
        position: "35%"
      },
      projectStartDate: new Date('03/25/2024'),
      projectEndDate: new Date('05/04/2024'),

    };
  },
  created() {

  },
  mounted() {

  },
  provide: {
    gantt: [DayMarkers, Selection, Toolbar, ExcelExport, PdfExport]
  },

  methods: {

    recordDoubleClick(args){
      console.log('recordDoubleClick')
      console.log(args.rowData)
      this.tarefaData = args.rowData
      this.showModalTarefa = true


    },

    confTarefa(){
      console.log('confTarefa')
    },

    toolbarClick(args){
      console.log('toolbarClick')
      console.log(args.item.id)

      if (args.item.id === "GanttExport_excelexport") {
        this.$refs.gantt.ej2Instances.excelExport();
      } else if (args.item.id === "GanttExport_csvexport") {
        this.$refs.gantt.ej2Instances.csvExport();
      } else if (args.item.id === "GanttExport_pdfexport") {
        var exportProperties = {
          fitToWidthSettings: {
            isFitToWidth: true
          },
        };
        this.$refs.gantt.ej2Instances.pdfExport(exportProperties);
      } else if (args.item.id === 'novaTarefa') {

        console.log('novaTarefa')
        this.tarefaData = {}
        this.submittedTarefa = false
        this.showModalTarefa = true

      }


    }

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div>

      <div class="col-lg-12 control-section">
        <div>
          <ejs-gantt ref='gantt' id="GanttExport"
                     :dataSource="data"
                     :rowHeight="46"
                     :height="height"
                     :highlightWeekends='true'
                     :allowSelection='true'
                     :taskFields="taskFields"
                     :labelSettings="labelSettings"
                     :treeColumnIndex="1"
                     :columns="columns"
                     :splitterSettings="splitterSettings"
                     :resourceFields="resourceFields" :resources="resources"
                     :projectStartDate="projectStartDate" :projectEndDate="projectEndDate"
                     :allowExcelExport="true" :allowPdfExport="true"
                     :toolbar= "toolbar"
                     :dateFormat="'dd/MM/y'"
                     :recordDoubleClick= "recordDoubleClick"
                     v-on:toolbarClick= "toolbarClick">
            <template v-slot:leftLabelTemplate="{data}">
              <div>
                <template>{{data.TaskName}} [ {{ data.Progress }} % ]</template>
              </div>
            </template>
            <template v-slot:rightLabelTemplate="{data}">
              <div v-if="data.ganttProperties.resourceInfo">
                <span v-for="resource in data.ganttProperties.resourceInfo" :key="resource.resourceId">
                  <img :src="require('@/assets/images/users/avatar-14.png')"
                       style="height: 40px;" :alt="resource.resourceName"/>
                  <span style="marginLeft:5px;marginRight:5px">{{ resource.resourceName }}</span>
                </span>
              </div>
            </template>
          </ejs-gantt>
        </div>
      </div>

    </div>


    <b-modal size="xl"
             :title="tarefaData.id > 0 ? `Editar Tarefa (${ tarefaData.id })` : 'Criando nova Tarefa'"
             v-model="showModalTarefa" centered hide-footer>
      <div>

<!--        <div class="card-body">-->

<!--          <div class="row">-->


<!--            <div class="col-md-6">-->
<!--              <label for="descricao">Descrição da ocorrência</label>-->
<!--              <div class="position-relative">-->
<!--                <input-->
<!--                    id="descricao"-->
<!--                    type="text"-->
<!--                    v-model="ocorFinalData.descricao"-->
<!--                    class="form-control"-->
<!--                    placeholder="Descrição da ocorrência"-->
<!--                    :class="{'is-invalid': submittedOcorFinal && !ocorFinalData.descricao}"/>-->
<!--                <div v-if="submittedOcorFinal && !ocorFinalData.descricao" class="invalid-feedback">-->
<!--                  <span>Campo descrição obrigatório, favor preencher.</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->



<!--            <div class="col-sm-3">-->
<!--              <div class="mb-3">-->
<!--                <label for="apirastreio">API Tracking</label>-->
<!--                <select-->
<!--                    id="apirastreio"-->
<!--                    v-model="ocorFinalData.apirastreio"-->
<!--                    class="form-control"-->
<!--                    :class="{'is-invalid': submittedOcorFinal && !ocorFinalData.apirastreio}">-->
<!--                  <option value="ACX">Acerta Express</option>-->
<!--                  <option value="AMAZON">Amazon</option>-->
<!--                  <option value="ANYMARKET">Any Market</option>-->
<!--                  <option value="B2WNOVA">B2W Nova Api</option>-->
<!--                  <option value="BLING">Bling</option>-->
<!--                  <option value="BRP">Braspres</option>-->
<!--                  <option value="CORREIOS">Correios</option>-->
<!--                  <option value="ESLC">ESL Cloud</option>-->
<!--                  <option value="FOCUSNFE">Focus NFe</option>-->
<!--                  <option value="JDL">JadLog</option>-->
<!--                  <option value="LEROYMER">Leroy Merlin</option>-->
<!--                  <option value="LJTO">LogJato</option>-->
<!--                  <option value="LOJAMEC">Loja do Mecânico</option>-->
<!--                  <option value="MAGALU">Magazine Luiza</option>-->
<!--                  <option value="OCO">OCOREN</option>-->
<!--                  <option value="QLTY">Quality</option>-->
<!--                  <option value="PATR">Patrus</option>-->
<!--                  <option value="RDV">Rodonavis</option>-->
<!--                  <option value="RELM">Realmed</option>-->
<!--                  <option value="SKYHUB">SkyHub</option>-->
<!--                  <option value="SOL">Solistica</option>-->
<!--                  <option value="SSW">SSW</option>-->
<!--                  <option value="TRAYCORP">TrayCorp</option>-->
<!--                  <option value="TNT">TNT</option>-->
<!--                  <option value="TRCO">Transcourier</option>-->
<!--                  <option value="TRV">Translovato</option>-->
<!--                  <option value="VTEX">Vtex</option>-->

<!--                </select>-->
<!--                <div v-if="submittedOcorFinal && !ocorFinalData.apirastreio" class="invalid-feedback">-->
<!--                  <span>Campo API Tracking obrigatório, favor preencher.</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->



<!--            <div class="col-sm-3">-->
<!--              <div class="mb-3">-->
<!--                <label for="statusdef">Definir Status</label>-->
<!--                <select-->
<!--                    id="statusdef"-->
<!--                    v-model="ocorFinalData.statusdef"-->
<!--                    class="form-control">-->
<!--                  <option value="ENP">Entregue no Prazo (ENP)</option>-->
<!--                  <option value="ECR">Entregue com Ressalva (ECR)</option>-->
<!--                  <option value="EAT">Entregue com Atraso (EAT)</option>-->
<!--                  <option value="CPE">Comprovante de Entrega (CPE)</option>-->

<!--                </select>-->

<!--              </div>-->
<!--            </div>-->




<!--          </div>-->




<!--        </div>-->


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalTarefa = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confTarefa">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


  </Layout>
</template>

<style scoped>
#ToolbarTemplate  .e-quickfilter::before {
  content: "\e7ee"
}
.fabric #ToolbarTemplate /deep/  .e-quickfilter::before,
.highcontrast #ToolbarTemplate /deep/  .e-quickfilter::before {
  content: '\e21c';
}
.bootstrap #ToolbarTemplate /deep/  .e-quickfilter::before {
  content: '\e946';
}
.bootstrap4 #ToolbarTemplate /deep/  .e-quickfilter::before {
  content: '\e714';
}
.tailwind #ToolbarTemplate /deep/  .e-quickfilter::before {
  content: '\e71b';
}
.fluent #ToolbarTemplate /deep/  .e-quickfilter::before,
.fluent2 #ToolbarTemplate /deep/  .e-quickfilter::before,
.fluent2-dark #ToolbarTemplate /deep/  .e-quickfilter::before,
.fluent2-highcontrast #ToolbarTemplate /deep/  .e-quickfilter::before
{
  content: '\e7f7';
}

</style>
